import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

export default function OnBoardingButton({ selectedTheme, error, state, username, setUsername  }) {
  
  return (        
    <>
      <h2 className={`onboarding-theme__h2 ${!selectedTheme ? "not-theme" : ""}`}>Welcome Art Traveler!</h2>
      <div className={`onboarding-theme__username ${!selectedTheme ? "not-theme" : ""}`}>
        <label>Choose a username</label>
        <PublicFormInput 
          error={error} 
          element="user_username" 
          fillWith={state.user_session.user_username}
          margin
          fullWidth={true}
          fixedPlaceholder='@'
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          secondaryColor={true}
        />
      </div>
    </>);
}